import { FormGroup } from '@angular/forms';
import { AssessmentQuestionInterface } from 'app/assessment/models';
import { ReviewInterface } from 'app/assessment/models/review.model';
import { RecommendationInterface } from 'app/recommendation/models';
import { BehaviorSubject } from 'rxjs';


export abstract class DynamicQuestionComponent {
  public readonly question: AssessmentQuestionInterface;
  public readonly form: FormGroup;
  public readonly imagePath: string;
  public reviews$: BehaviorSubject<Readonly<ReviewInterface[]>>;
  public recommendations$: BehaviorSubject<Readonly<RecommendationInterface[]>>;

  public get isValid(): boolean {
    return this.form.controls[this.question.id].valid;
  }
}
